import styled from 'styled-components'
import Autocomplete from "@mui/material/Autocomplete";

export const Select = styled(Autocomplete)`
  background-color: white;
`
